import NodeRSA from 'node-rsa'
import config from '../config'

export function encrypt (text) {
  const key = new NodeRSA(config.publicKey)
  return key.encrypt(text, 'base64')
}
